<template>
  <el-skeleton class="detail_skeleton" animated>
    <template slot="template">
      <div class="cover">
        <el-skeleton-item class="img" variant="image" />
      </div>
      <div class="desc">
        <el-skeleton-item variant="h1"/>
        <div class="sub_desc">
          <div class="item" v-for="(item, index) in 7" :key="index">
            <el-skeleton-item class="key" variant="p"/>
            <el-skeleton-item class="value" variant="p"/>
          </div>
          <div class="item">
            <el-skeleton-item class="key qty" variant="p"/>
            <el-skeleton-item class="value qty" variant="p"/>
          </div>
          <el-skeleton-item variant="button"/>
          <el-skeleton-item variant="button"/>
        </div>
      </div>
    </template>
  </el-skeleton>
</template>

<script>
export default {
  name: 'Detail_Skeleton'
}
</script>

<style lang="scss" scoped>
.detail_skeleton {
  &::v-deep .el-skeleton {
    display: flex;
    .cover {
      height: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      padding-right: 10px;
      .img {
        width: 270px;
        height: 100%;
      }
    }
    .desc {
      flex: 1;
      padding: 0 10px;
      .el-skeleton__h1 {
        height: 65px;
      }
      .sub_desc {
        margin-top: 13px;
        .item {
          display: flex;
          margin-bottom: 10px;
          .key,
          .value {
            height: 20px;
          }
          .key {
            width: 140px;
            &.qty {
              height: 30px;
            }
          }
          .value {
            width: 250px;
            margin-left: 20px;
            &.qty {
              width: 200px;
              height: 30px;
            }
          }
        }
      }
      .el-skeleton__button {
        width: 170px;
        &:last-child {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
